import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { createLoadOrder } from "../../../../actions/order";
import { usePublicViewEntityContext } from "../../../../context/PublicViewEntityProvider";
import SelectTemplatePopup from "./SelectTemplatePopup";

export default function SelectTemplatePopupWithContext(props) {
  const {
    entityLayoutId,
    entityTemplateId,
    onUpdateEntity,
    isShop,
    entity,
    entityOrderId,
    labelTitle
  } = usePublicViewEntityContext();

  const dispatch = useDispatch();

  const {
    onClose,
    layouts,
    selectedTheme,
    selectedTemplate,
    initialFilters,
    initialCategory,
    zIndex,
    ...otherProps
  } = props;

  const handleClickSelect = useCallback(async (theme) => {
    if (!theme || !theme.template_type) {
      return;
    }

    if (theme.template_type === 'TEMPLATE') {
      if (!theme.parent_id || !theme.public_view_template_id) {
        console.warn('Missing required template properties:', theme);
        return;
      }

      // Wait for both updates to complete before reloading
      await Promise.all([
        onUpdateEntity('public_view_layout_id', entityLayoutId)(theme.parent_id),
        onUpdateEntity('public_view_template_id', entityTemplateId)(theme.public_view_template_id)
      ]);
      
      // Reload order to get updated template_data after template changes complete
      if (entityOrderId) {
        dispatch(createLoadOrder(entityOrderId, true));
      }
    } else {
      if (!theme.public_view_template_id) {
        console.warn('Missing public_view_template_id for layout:', theme);
        return;
      }

      // Wait for both updates to complete before reloading
      await Promise.all([
        onUpdateEntity('public_view_layout_id', entityLayoutId)(theme.public_view_template_id),
        onUpdateEntity('public_view_template_id', entityTemplateId)('')
      ]);

      // Reload order to get updated template_data after layout changes complete
      if (entityOrderId) {
        dispatch(createLoadOrder(entityOrderId, true));
      }
    }
  }, [entityLayoutId, entityTemplateId, entityOrderId, onUpdateEntity, dispatch]);

  return (
    <SelectTemplatePopup
      onClose={onClose}
      layouts={layouts}
      selectedTheme={selectedTheme}
      selectedTemplate={selectedTemplate}
      initialFilters={initialFilters}
      initialCategory={initialCategory}
      zIndex={zIndex}
      onClickSelect={handleClickSelect}
      isShop={isShop}
      entity={entity}
      labelTitle={labelTitle}
      {...otherProps}
    />
  );
}
